import { ModuleLayout, type ModuleTab } from './ModuleLayout.js';
import { useVisibleTabs } from '../useNavAccess.js';
import { useTenantSettings } from '../../lib/tenantSettings.js';
import { quotesVisible } from '../../lib/types/tenantSettings.js';
import { useCapabilities } from '../../lib/capabilities.js';

export const CRM_TABS: readonly ModuleTab[] = [
  { id: 'overview', hrefSuffix: '', label: 'نمای کلی' },
  { id: 'leads', hrefSuffix: '/leads', label: 'سرنخ‌ها' },
  { id: 'customers', hrefSuffix: '/customers', label: 'مشتریان' },
  { id: 'activities', hrefSuffix: '/activities', label: 'فعالیت‌ها و پیگیری‌ها' },
  { id: 'quotes', hrefSuffix: '/quotes', label: 'پیش‌فاکتورها' },
  { id: 'orders', hrefSuffix: '/orders', label: 'سفارش‌های فروش' },
  { id: 'invoices', hrefSuffix: '/invoices', label: 'فاکتورهای فروش' },
  { id: 'returns', hrefSuffix: '/returns', label: 'برگشت از فروش' },
  { id: 'my-sales', hrefSuffix: '/my-sales', label: 'فروش من' },
  { id: 'team', hrefSuffix: '/team', label: 'عملکرد تیم فروش' },
  { id: 'call-base', hrefSuffix: '/call-base', label: 'پایگاه تماس' },
  { id: 'sms-panel', hrefSuffix: '/sms-panel', label: 'پنل پیامک' },
  { id: 'assistant', hrefSuffix: '/assistant', label: 'دستیار' },
];

export function CrmModuleLayout() {
  const settings = useTenantSettings();
  const { hasCapability } = useCapabilities();
  const permittedTabs = useVisibleTabs('crm', CRM_TABS);
  // D-021: presentation only — the API enforces both keys.
  const hidden = new Set<string>();
  if (!quotesVisible(settings)) hidden.add('quotes');
  if (!hasCapability('sales.commission.read-own')) hidden.add('my-sales');
  const tabs = permittedTabs.filter((tab) => !hidden.has(tab.id));
  return (
    <ModuleLayout
      moduleId="crm"
      title="فروش و CRM"
      subtitle="از سرنخ تا سفارش فروش، در یک مسیر"
      tabs={tabs}
      cta={{
        label: 'سرنخ جدید',
        icon: 'plus',
        hrefSuffix: '/leads',
        tabIds: ['overview'],
      }}
    />
  );
}
